// components/PopupMessage.tsx
import React, { useEffect } from 'react';

interface PopupMessageProps {
  message: string;
  type: string;
  timeout?: number; // in milliseconds
  onClose?: () => void;
}

const PopupMessage: React.FC<PopupMessageProps> = ({
  message,
  type,
  timeout = 3000,
  onClose,
}) => {
  useEffect(() => {
    const timer = setTimeout(() => {
      if (onClose) onClose();
    }, timeout);
    return () => clearTimeout(timer);
  }, [timeout, onClose]);

  return (
    <div className="popup-message">
      <span>{message}</span>
      <button className="close-popup" onClick={onClose}>
        ×
      </button>
    </div>
  );
};

export default PopupMessage;
